export default __webpack_public_path__ + "static/media/app-store-black.d634fc6b.svg";